import { PaletteOptions } from '@mui/material';

export const darkColorPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#8BB770',
    light: '#C5DBB8',
    dark: '#0E7432',
    contrastText: '#000',
  },
  text: {
    primary: '#fff',
    secondary: '#F6E8AF',
  },
  background: {
    default: '#000',
    paper: '#333',
  },
};
